// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__bwPs6","detailsBorder":"styles_detailsBorder__25zfo"};